/* External dependencies */
import { concat, from, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { listUsers } from '../../list-users/redux/action';
import { updateUserForAdminError, updateUserForAdminSuccess } from './action';
import { updateUserForAdminMutation } from './mutation';
import { UpdateUserForAdminActionTypes, UpdateUserForAdminInput, UpdateUserForAdminRequest } from './types';

export default function updateUserForAdminEpic(action$, state$) {
  return action$.pipe(
    filter(
      (action: UpdateUserForAdminRequest) =>
        action.type === UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_REQUEST,
    ),
    switchMap((action: UpdateUserForAdminRequest) =>
      from(updateUserForAdmin(action.input)).pipe(
        switchMap(() => {
          const currentState = state$.value;
          const { query, filter, size, currentPage } = currentState.listUsers;

          return concat(
            from([updateUserForAdminSuccess()]),
            from([listUsers({ query, filter, currentPage, size })]),
          );
        }),
        catchError((error) => of(updateUserForAdminError(error))),
      ),
    ),
  );
}

export async function updateUserForAdmin(input: UpdateUserForAdminInput): Promise<void> {
  const graphQLClient = await getClient();

  const mutation = { mutation: updateUserForAdminMutation, variables: { input } };

  const {
    data: { updateUserForAdmin },
  } = await graphQLClient.mutate(mutation);

  return updateUserForAdmin;
}
